const invariant = require('invariant');
const rebound = require('rebound');

const SpringsMixin = (springs = []) => {

  return {

    getInitialState() {
      return springs.reduce((springValues, springConfiguration) => {

        springValues[`${ springConfiguration.key }SpringValue`] = springConfiguration.initialValue || 0;

        return springValues;
      }, {});

    },

    componentWillMount() {

      const springSystem = new rebound.SpringSystem();

      this._springSystem = springSystem;
      this.springRefs = {};

      springs.forEach((springConfiguration) => {

        springConfiguration.tension = springConfiguration.tension || 200;
        springConfiguration.friction = springConfiguration.friction || 15;
        springConfiguration.initialValue = springConfiguration.initialValue || 0;

        this.addSpring(springConfiguration);
      });
    },

    addSpring(springConfiguration) {

      invariant(springConfiguration.key, 'Spring must define a key attribute');

      const spring = this._springSystem.createSpringWithConfig(springConfiguration);
      spring.addListener({
        onSpringUpdate: () => {

          // rebound already uses rAF for its changes, but this will also allow the react
          // render to happen in the rAF window

          window.requestAnimationFrame(() => {
            if (this.isMounted()) {
              this.setState({
                [`${ springConfiguration.key }SpringValue`]: spring.getCurrentValue(),
              });
            }
          });
        },
      });

      spring.setCurrentValue(springConfiguration.initialValue);

      this.springRefs[springConfiguration.key] = spring;
    },

    removeSpring(springName) {
      if (this.springRefs[springName]) {
        this.springRefs[springName].destroy();
        delete this.springRefs[springName];
      }
    },

  };
};

module.exports = SpringsMixin;
